<template>
  <div class="modal-wrapper">
    <div id="modalId" ref="modalId" v-click-outside="closeModal" class="modal-container" :class="[{'modal-container-center': center}, type]">
      <template v-if="!modalWithCard">
        <div class="modal-header">
          <slot name="header" />
        </div>

        <div v-if="$slots.body" class="modal-body text-center">
          <slot name="body" />
        </div>

        <div v-if="$slots.footer" class="modal-footer">
          <slot name="footer" />
        </div>
      </template>

      <template v-else>
        <md-card :class="cardClasses">
          <div v-if="$slots.header" class="modal-header">
            <slot name="header" />
          </div>

          <div v-if="$slots.body" class="modal-body">
            <md-card-content>
              <slot name="body" />
            </md-card-content>
          </div>

          <div v-if="$slots.footer" class="modal-footer">
            <md-card-actions>
              <slot name="footer" />
            </md-card-actions>
          </div>
        </md-card>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: "Modal",
  props: {
    type: String,
    cardClasses: String,
    modalWithCard: Boolean
  },
  data() {
    return {
      center: false,
    };
  },
  mounted() {
    this.$nextTick(function () {
      var modal = this.$refs.modalId;

      if (modal != null && modal.scrollHeight < modal.offsetParent.clientHeight){
        this.center = true;
      }
    })
  },
  methods: {
    closeModal: function() {
      this.$emit("close");
    }
  }
};
</script>

<style>
    .modal-body a {
        color: #3678b6 !important;
    }

    .modal-body a:hover {
        color: #3678b6 !important;
    }
</style>